namespace SP {
    export enum ItemType {
        Normal = 0,
        NormalWithBundleContent = 1,
        Production = 2,
        Service = 10,
        Bundle = 20,
        ProducibleBundle = 21,
        Freight = 25,
        DontImport = 27,
        Ignore_FulfillFirst = 28,
        Ignore_FulfillLast = 29,
        Ignore_FulfillInstantly = 30
    }
}